import { useOnce } from "src/hooks/lifecycle";
import { useHistory } from "react-router-dom";
import { scrollToTop } from "src/utils/scroll";

/*
NOTE(kevinh): This component used to be called within getLazyComponentWrapper in src/router. 
However, this wasn't actually working due to history.listen being a trailing operation and 
it was moved up to PageSetRouter instead.

Issue was called out here: https://noomhq.atlassian.net/browse/GT-1565
*/
const ScrollToTop = () => {
  const history = useHistory();

  useOnce(() => {
    return history.listen((location, action) => {
      if (action === "POP") {
        return;
      }
      scrollToTop();
    });
  });

  return null as JSX.Element;
};

export default ScrollToTop;
